<template>
  <div class="card">
    <div class="card-body">
      <b-table head-row-variant="info" table-variant="white"
               :items="targetList"
               :fields="targetListHeaders"
               hover
               responsive
               sort-icon-left
               show-empty>
        <template #empty="scope">
          <h6 class="text-center my-5">
            {{scope.loading ? "Lütfen Bekleyin" : errorMessageAll ? errorMessageAll : "Veri Bulunamadı" }}
          </h6>
        </template>
        <template #cell(startDate)="data">
          <div class="text-start">
            {{ formattedDate(data.item.startDate)}}
          </div>
        </template>
        <template #cell(finishDate)="data">
          <div class="text-start">
            {{ formattedDate(data.item.finishDate)}}
          </div>
        </template>
        <template #table-busy>
          <div class="text-center">
            <b-spinner variant="primary" size="lg" label="Lütfen Bekleyin...">
            </b-spinner>
          </div>
        </template>
        <template #cell(process)="data">
          <div class="text-center">
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" icon color="amber darken-2" @click="openAddCurrentDialog(data.item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
              </template>
              <span>Düzenle</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{on, attrs}">
                <v-btn v-bind="attrs" v-on="on" icon color="amber darken-2" @click="_currentTargetDelete(data.item.id)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
              <span>Sil</span>
            </v-tooltip>
          </div>
        </template>
      </b-table>
      <NewTargetDialog
          :targetProp="editCurrentTargetProp"
          :processType="'edit'"
          :showDialog="editCurrentTargetDialog"
          @dialogChange="(data) => (editCurrentTargetDialog = data)">
      </NewTargetDialog>
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from "vuex";
import NewTargetDialog from "@/components/management/target/current/dialogs/NewCurrentTargetDialog.vue";
import {formattedDate} from "@/momentHelper";
export default {
  name: "ResultsTableView",
  components: {NewTargetDialog},
  data() {
    return {
      editCurrentTargetProp: null,
      editCurrentTargetDialog: false,
    };
  },
  computed: {
    ...mapState("dashboard",["errorMessageAll"]),
    ...mapState("target",["targetListHeaders","targetList"])
  },
  methods: {
    formattedDate,
    ...mapActions("target",["currentTargetDelete"]),
    openAddCurrentDialog(data) {
      this.editCurrentTargetProp = data;
      this.editCurrentTargetDialog = true;
    },

    // await this.stockImageDelete({
    //   params: {},
    //   body: {},
    //   urlSegments: [item.id],
    // });


    async  _currentTargetDelete(id){
      await this.currentTargetDelete({
        params: {},
        body:{},
        urlSegments: [id],
      })
    }
  },
  watch: {
    "editCurrentTargetDialog": function (newVal) {
      if (!newVal)
        this.editCurrentTargetProp = null;
    }
  }
};
</script>

<style scoped>

</style>